<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Usuário
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-4">
          <div class="col-md-4">
            <label><span class="required">*</span> Usuário:</label>
            <select
              v-model="aditionalHour.user_id"
              class="form-control"
            >
              <option
                v-for="user in users"
                :key="user.id"
                :value="user.id"
              >
                {{ user.name }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Tempo</label>
            <input
              v-model="aditionalHour.time"
              v-mask="'##:##:##'"
              type="text"
              class="form-control"
              placeholder="HH:MM:SS"
            >
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Tipo</label>
            <select
              v-model="aditionalHour.type"
              class="form-control"
            >
              <option value="Acrescimo">
                Acrescimo
              </option>
              <option value="Decréscimo">
                Decréscimo
              </option>
            </select>
          </div>
        </div>
        <div class="block text-right mt-1">
          <router-link
            to="/aditionalHours"
            class="btn btn-back"
          >
            <i class="fa fa-arrow-left" /> Voltar
          </router-link>
          <a
            class="btn btn-add ml-1"
            @click="save"
          >
            Salvar
            <i class="fa fa-save" />
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiErrorMessage } from '@/utils/apiError'

export default {
  data() {
    return {
      users: [],
      aditionalHour: {
        user_id: '',
        time: '',
        type: 'Acrescimo',
      },
    }
  },
  mounted() {
    const self = this

    self.getUsers()

    const { id } = self.$route.params
    if (id) {
      self.getAditionalHour(id)
    }
  },
  methods: {
    save() {
      const self = this

      if (self.aditionalHour.id) return self.edit()

      const api = `${this.$store.state.api}aditionalHours`

      const fd = self.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          self.$message(
            'Sucesso',
            'Hora adicional cadastrada com sucesso',
            'success',
          )
          this.$router.push('/aditionalHours')
        })
        .catch(error => {
          self.$message('Erro', apiErrorMessage(error), 'error')
        })
    },
    edit() {
      const self = this
      const api = `${self.$store.state.api}aditionalHours/${self.aditionalHour.id}`

      const fd = self.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          self.$message(
            'Sucesso',
            'Hora adicional cadastrada com sucesso',
            'success',
          )
          this.$router.push('/aditionalHours')
        })
        .catch(error => {
          self.$message('Erro', apiErrorMessage(error), 'error')
        })
    },
    makeFormData() {
      const self = this

      const fd = new FormData()

      if (!self.aditionalHour.time || self.aditionalHour.time.length < 8) {
        self.$message('Erro', 'Preencha horas válidas', 'error')
        return false
      }

      const hms = self.aditionalHour.time.split(':')
      const miliseconds = (+hms[0] * 60 * 60 + +hms[1] * 60 + +hms[2]) * 1000

      fd.append('user_id', self.aditionalHour.user_id)
      fd.append(
        'miliseconds',
        self.aditionalHour.type == 'Acrescimo' ? miliseconds : miliseconds * -1,
      )

      if (self.aditionalHour.id) {
        fd.append('id', self.aditionalHour.id)
        fd.append('_method', 'PUT')
      }

      return fd
    },
    getUsers() {
      const self = this
      const api = `${this.$store.state.api}users?paginated=false`

      axios
        .get(api)
        .then(response => {
          self.users = response.data.data
        })
        .catch(error => {
          self.$message('Erro', error.response.data, 'error')
        })
    },
    msToTime(duration) {
      const milliseconds = parseInt((duration % 1000) / 100)
      let seconds = Math.floor((duration / 1000) % 60)
      let minutes = Math.floor((duration / (1000 * 60)) % 60)
      let hours = Math.floor((duration / (1000 * 60 * 60)) % 24)

      hours = hours < 10 ? `0${hours}` : hours
      minutes = minutes < 10 ? `0${minutes}` : minutes
      seconds = seconds < 10 ? `0${seconds}` : seconds

      return `${hours}:${minutes}:${seconds}`
    },
    getAditionalHour(id) {
      const self = this
      const api = `${self.$store.state.api}aditionalHours/${id}`

      axios
        .get(api)
        .then(response => {
          const aditionalHour = response.data.data[0]
          aditionalHour.time = self.msToTime(aditionalHour.miliseconds)
          self.aditionalHour = aditionalHour
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
